import React, { useState } from 'react';
import { AlertModal, PrivacyAndTerms } from '../';
import { DEFAULT_PRIVACY_POLICY } from '../../constants/privacy-policy';
import { DEFAULT_TERMS_AND_CONDITIONS } from '../../constants/terms-and-conditions';
import './style.css';
import ReactGA from 'react-ga';

export const TermsArea = ({
  privacyPolicy,
  termsConditions,
  isSignatureRequire,
  isChecked,
  handleCheck,
  campaignColor,
}) => {
  const [openModal, setOpenModal] = useState(false);

  const handleModal = (modalType) => {
    if (modalType) {
      const action =
        modalType === 'privacy'
          ? 'Open privacy policy'
          : 'Open Terms & Conditions';

      ReactGA.event({
        category: 'Terms',
        action: action,
      });
    }
    setOpenModal(modalType);
  };

  const MODAL_TYPE = {
    privacy: {
      heading: 'Privacy Policy',
      text: privacyPolicy || DEFAULT_PRIVACY_POLICY,
    },
    terms: {
      heading: 'Terms & Conditions',
      text: termsConditions || DEFAULT_TERMS_AND_CONDITIONS,
    },
  };

  return (
    <div className='terms-area'>
      {!isSignatureRequire && (
        <input
          type='checkbox'
          className='ui checkbox'
          checked={isChecked}
          onChange={handleCheck}
        />
      )}
      <label>
        {!!isSignatureRequire
          ? `Sign below to agree to the `
          : `I agree to the `}

        <TermButton
          onClick={() => handleModal('privacy')}
          color="black"
        >
          Privacy Policy
        </TermButton>

        {` and `}

        <TermButton onClick={() => handleModal('terms')} color="black">
          Terms & Conditions
        </TermButton>

        {!!isSignatureRequire && `. Tap below to sign.`}
      </label>

      <AlertModal
        isVisible={openModal}
        content={
          <PrivacyAndTerms
            heading={openModal && MODAL_TYPE[openModal].heading}
            text={openModal && MODAL_TYPE[openModal].text}
          />
        }
        onClose={() => handleModal(false)}
      />
    </div>
  );
};

const TermButton = ({ color, onClick, children }) => {
  return (
    <button
      className='ancora-button'
      style={{
        color: color,
      }}
      onClick={onClick}
    >
      {children}
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/components/TermsArea/index.jsx